import {
  VARIABLENODE_NAME,
  VARIABLENODE_TAG,
} from '~shared/richtext/nodes/variable.node'

import { TiptapSuggestionsConfig } from '@/entities/tiptap-suggestions'
import type { TextVariableDto } from '@/entities/variables/model/dtos'

import type { SuggestionKeyDownProps } from '@tiptap/suggestion'

export const variablesExtensionConfig = new TiptapSuggestionsConfig({
  name: VARIABLENODE_NAME,
  nodeTag: VARIABLENODE_TAG,
  character: '$',
  supportedNavigationKeys: ['ArrowUp', 'ArrowDown', 'Enter'],
})

export type VariablesSuggestionsCommandReturn = {
  variable: TextVariableDto
}

export interface VariablesSuggestionsHandle {
  onKeyDown: (props: SuggestionKeyDownProps) => boolean
}
